export default __webpack_public_path__ + "static/media/xCloud-blue-icon.c1bb9ce4.png";